import React, { useState } from "react";

import classNames from "classnames";
import { useField } from "formik";
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

import { ReactComponent as IconError18 } from "../../icons/icon/18/a-icon-error-18.svg";
import { ReactComponent as IconEyeHide18 } from "../../icons/icon/18/a-icon-eye-hide-18.svg";
import { ReactComponent as IconEyeShow18 } from "../../icons/icon/18/a-icon-eye-show-18.svg";

const PasswordInput = ({
  id = "",
  label,
  name,
  required = null,
  className = null,
  forceInvalid = false,
  onFocus = () => {},
  autocomplete = "",
}) => {
  const [showPassword, setShowPassword] = useState();
  const [field, meta] = useField(name);

  return (
    <Form.Group className={classNames(className, { required })}>
      <InputGroup className={classNames("append", { "is-invalid": meta.touched && meta.error })}>
        <Form.Control
          type={showPassword ? "text" : "password"}
          isInvalid={(meta.touched && meta.error) || forceInvalid}
          name={name}
          onFocus={onFocus}
          autocomplete={autocomplete}
          id={id || name}
          {...field}
          aria-errormessage={`${id || name}-error`}
          aria-invalid={(meta.touched && meta.error) || forceInvalid}
        />
        <Form.Label htmlFor={id}>
          {label}
        </Form.Label>
        <InputGroup.Append>
          <InputGroup.Text
            style={{ cursor: "pointer" }}
            className="text-grey-dark"
            onClick={() => setShowPassword((prevState) => !prevState)}
          >
            {showPassword ? <IconEyeHide18 /> : <IconEyeShow18 />}
          </InputGroup.Text>
        </InputGroup.Append>
      </InputGroup>
      {meta.touched && meta.error && (
        <Form.Text className="invalid-feedback" id={`${id || name}-error`}>
          <IconError18 />{meta.error}
        </Form.Text>
      )}
    </Form.Group>
  );
};

PasswordInput.propTypes = {
  autocomplete: PropTypes.string,
  className: PropTypes.string,
  forceInvalid: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onFocus: PropTypes.func,
  required: PropTypes.bool,
};

export default PasswordInput;
